export const userRoles = ['Editor', 'Admin'];

export default userRoles;
